module.exports = __webpack_public_path__ + "img/10m.581de14c.png";